/**
 * @file index.tsx
 *
 * @fileoverview Renders a link that looks like a button.
 */
import React from "react";
import styles from "./buttonLink.module.scss";

export type ButtonLinkProps = React.ButtonHTMLAttributes<any> & {
  /**
   * Text for the button
   *
   * @default null
   */
  children?: React.ReactNode;
};

/**
 * The ButtonLink component renders a button that looks like a link. It can be used when you need to use a button (becuase it requires user interaction and its not a
 * link to another page) but you still want it to look like a link.
 */
export const ButtonLink = ({ children, ...props }: ButtonLinkProps) => {
  return (
    <button className={styles.buttonLink} {...props}>
      {children}
    </button>
  );
};
